import React, { useState } from 'react';

interface VideoContentRendererProps {
  payload: {
    // Prefer backend-provided view_url for any viewing/preview, fall back to file_url for legacy data
    view_url?: string;
    file_url?: string;
    file_path?: string; // backend-internal; do not use to build URLs on FE
    poster?: string;
    transcript_url?: string;
  };
  file: {
    file_id: string;
    file_name: string;
    file_type: string;
    file_size: number;
    // Prefer backend-provided view_url for any viewing/preview, fall back to file_url for legacy data
    view_url?: string;
    file_url?: string;
    file_path?: string; // backend-internal; do not use to build URLs on FE
    options: any;
  };
}

export const VideoContentRenderer: React.FC<VideoContentRendererProps> = ({ payload, file }) => {
  const [videoError, setVideoError] = useState(false);

  const handleVideoError = () => {
    setVideoError(true);
  };

  if (videoError) {
    return (
      <div className="text-center">
        <div className="text-gray-500 dark:text-gray-400 mt-4">
          <div className="text-4xl mb-2">🎥</div>
          <p>Không thể tải video</p>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center">
      <video
        src={
          file.view_url ||
          payload.view_url ||
          file.file_url ||
          payload.file_url ||
          ''
        }
        controls
        className="max-w-full h-auto rounded-lg shadow-lg mx-auto"
        poster={payload.poster}
        onError={handleVideoError}
      >
        Trình duyệt của bạn không hỗ trợ video.
      </video>
      {payload.transcript_url && (
        <div className="mt-2">
          <a
            href={payload.transcript_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-blue-600 dark:text-blue-400 hover:underline"
          >
            Xem phụ đề
          </a>
        </div>
      )}
    </div>
  );
};
